import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { useCallback, useMemo, useState } from 'react'

import { ICheckedValue } from 'core-components/library/list/types'
import { LoaderOverlay } from 'core-components/library/loader'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'

import { SimplePartnerTable } from '../../../../components/simplePartnerTable'
import { IAttachedPartner } from '../../models/attachedPartner'

import { ADD_PARTNERS_CRUD_SOURCE_KEY } from './configs'
import { getJbpPartnersCrud } from './helpers/getJbpPartnersCrud'
import { IAddPartnersTableProps } from './models/addPartnersTableProps'

import styles from './AddPartnersTable.module.scss'

export const AddPartnersTable = ({
  onCheckedItemsSave,
  globalPartnerId,
  fYear,
}: IAddPartnersTableProps) => {
  const [checkedValues, setCheckedValues] = useState<ICheckedValue[]>([])
  const [isLoaded, setIsLoaded] = useState(false)

  const crud = getJbpPartnersCrud()

  const source = useMemo(() => {
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'GlobalPartnerId',
          operator: Operator.EQUAL,
          value: globalPartnerId,
        },
      ],
    }
    crud.setFilter(filter)
    return crud
  }, [globalPartnerId, crud])

  const handleCheck = useCallback((item: IWWPartners, state: boolean) => {
    setCheckedValues((prevState) => {
      if (state) {
        return [
          ...prevState,
          {
            key: item.PartnerID,
            value: 'full',
          },
        ]
      }

      return prevState.filter((it) => it.key !== item.PartnerID)
    })
  }, [])

  const handleClear = useCallback(() => {
    setCheckedValues([])
  }, [])

  const handleSave = useCallback(async () => {
    const mappedValues = checkedValues.map<IAttachedPartner>((it) => ({
      GlobalPartnerId: globalPartnerId,
      FYear: fYear,
      PartnerId: it.key.toString(),
    }))
    setIsLoaded(true)
    await onCheckedItemsSave(mappedValues)
    setIsLoaded(false)
  }, [onCheckedItemsSave, checkedValues, globalPartnerId, fYear])

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <SimplePartnerTable
          source={source}
          useRowCheckbox
          withFilterArea
          sourceKey={ADD_PARTNERS_CRUD_SOURCE_KEY}
          onCheck={handleCheck}
          bulkClear={handleClear}
          bulkSave={handleSave}
          checkedValues={checkedValues}
          hideTableIfFiltersEmpty
        />
        <LoaderOverlay show={isLoaded} />
      </div>
    </div>
  )
}
